import React from 'react';

import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {CREATE_ACCOUNT_STEPS, STEP_TITLE} from 'src/modules/create-account/steps';

import {Stepper, StepperItem} from '@pb/kit-component-stepper';


type Props = {
    selectedStep: typeof CREATE_ACCOUNT_STEPS[keyof typeof CREATE_ACCOUNT_STEPS],
    onChangeStep?: (step: CREATE_ACCOUNT_STEPS) => void,
};

const STEPS = [{
    caption: STEP_TITLE[CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS],
    step: CREATE_ACCOUNT_STEPS.ACCOUNT_DETAILS,
}, {
    caption: STEP_TITLE[CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS],
    step: CREATE_ACCOUNT_STEPS.ACCOUNT_SETTINGS,
}, {
    caption: STEP_TITLE[CREATE_ACCOUNT_STEPS.LICENSE_CREATE],
    step: CREATE_ACCOUNT_STEPS.LICENSE_CREATE,
}];

export const CreateAccountProgressBar = (props: Props) => {
    const {selectedStep, onChangeStep} = props;
    const {hasAccess} = useAdminAccessRight();

    const hasCreateLicenseAccess = hasAccess(ACCESS_RIGHTS.LICENSE_SCREEN_CREATE);
    const visibleSteps = STEPS.filter(
        step => step.step !== CREATE_ACCOUNT_STEPS.LICENSE_CREATE || hasCreateLicenseAccess,
    );

    const selectedIndex = visibleSteps.findIndex(step => step.step === selectedStep);
    const activeStepIndex = selectedIndex !== -1
        ? selectedIndex
        : Math.max(0, visibleSteps.length - 1);

    return (
        <Stepper activeStep={activeStepIndex}>
            {visibleSteps.map((step, index) => (
                <StepperItem
                    key={`${step.step}`}
                    caption={step.caption}
                    onClick={() => {
                        if (onChangeStep) {
                            onChangeStep(step.step);
                        }
                    }}
                    disabled={selectedStep < step.step}
                    active={selectedStep === step.step}
                    completed={selectedStep > step.step}
                    isFirst={index === 0}
                />
            ))}
        </Stepper>
    );
};
